import { useQuery } from "@tanstack/react-query";

const { default: apiClient } = require("lib/api-client");

const fetchDesigns = async ({ queryKey }) => {
  const [, { sortBy, order, searchTerm, styleNumber, location, stockStatus, goldColor, goldQlty, diaQlty, designClass }] = queryKey;

  const response = await apiClient.post("/api/v1/stocks/getStyleNumberStockDetails", {
    sortBy,
    order,
    searchTerm,
    styleNumber,
    location,
    stockStatus,
    goldColor,
    goldQlty,
    diaQlty,
    designClass,
    stockStatus,
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return {
    subStockSetDesigns: response.data.styleStocks,
    totalCount: response.data.totalStyleStocks,
    totalSerachAndFilter: response.data.totalSerachAndFilter,
  };
};

export const useSubStockSetDesings = ({
  sortBy = "Design Date",
  order = "asc",
  searchTerm = "",
  styleNumber = "",
  location = [],
  stockStatus = "",
  goldColor = [],
  goldQlty = [],
  diaQlty = [],
  designClass = [],
}) => {
  return useQuery({
    queryKey: [
      "subStockSetDesigns",
      {
        sortBy,
        order,
        searchTerm,
        styleNumber,
        location,
        stockStatus,
        goldColor,
        goldQlty,
        diaQlty,
        designClass,
        stockStatus,
      },
    ],

    queryFn: ({}) =>
      fetchDesigns({
        queryKey: [
          "subStockSetDesigns",
          {
            sortBy,
            order,
            searchTerm,
            styleNumber,
            location,
            stockStatus,
            goldColor,
            goldQlty,
            diaQlty,
            designClass,
            stockStatus,
          },
        ],
      }),
  });
};
